// /client/src/components/CareersCta.js
import React, { useState, useEffect } from 'react';

const CareersCta = ({ colorMode = "colorBlack" }) => {

  return (
    <div className="mt-5 p-0 is-flex is-justify-content-center">
        <a
            href="https://kindersbbq.atsondemand.com/#/" 
            target='_blank'
        >
            <button 
            className="button"
            style={{
                transition: 'all 0.2s ease-in-out',
                cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
            }}
            >
            View Open Positions
            </button>
        </a>
      
    </div>
  );
};

export default CareersCta;